module.exports = __webpack_public_path__ + "static/robust-hybrid-5e3f6adfa3a0416d58cc9e302377c433.svg";